export default __webpack_public_path__ + "static/media/ABBvoice_W_Bd.e8d93c0d.woff";